import { collection, setDoc, doc, getDoc, increment, updateDoc, Timestamp } from 'firebase/firestore';
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
//@ts-ignore
import {db} from '../utils/firebase'
import { FaChevronDown, FaDrumstickBite, FaLanguage, FaLeaf, FaUtensils, FaTimes, FaBox } from "react-icons/fa"; // Using react-icons
import Loading from '../components/Global/Loading';

import { 
  FaCocktail,
  FaHeart,
  FaShoppingCart,
  FaHome,
  FaBuilding
} from 'react-icons/fa';
import { MdFoodBank, MdRestaurantMenu, MdDeliveryDining, MdOutlineDeliveryDining, MdAddBox, MdRestaurant, MdTakeoutDining } from 'react-icons/md';
import { RiTakeawayFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";

import { GiChefToque, GiFruitBowl, GiHotMeal } from 'react-icons/gi';
import FloatingMenu from "../pages/FloatingMenu";
import { v4 as uuidv4 } from 'uuid'; // for unique order ID

export default function ConsumerMenu() {
  const { businessId } = useParams();
  const [menuData, setMenuData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const hasFetchedRef = useRef(false);
  // const [openCategory, setOpenCategory] = useState(null);
  const [openCategories, setOpenCategories] = useState([]); // Start with empty array
  //console.log("open category", openCategories)
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [isServiceActive, setIsServiceActive] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState('englishMenu');
  // New state for order summary popup
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [selectedItemsDetails, setSelectedItemsDetails] = useState([]);
  const [orderOption, setOrderOption] = useState('');

  //console.log("selected item detals", selectedItemsDetails)
  
  // New state for order details
  const [tableNumber, setTableNumber] = useState('');
  const [cookingInstructions, setCookingInstructions] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [roomNumber, setRoomNumber] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  
  // Business type and delivery availability (should be fetched from userData)
  const [businessType, setBusinessType] = useState(); // Default to Restaurant
  const [deliveryAvailable, setDeliveryAvailable] = useState(); // Default to false
  const [takeAwayAvailable, setTakeAwayAvailable] = useState(); // Default to false
  const [itemQuantities, setItemQuantities] = useState({});
  
  //Floating Menu button
  const [menuDataPP, setMenuDataPP] = useState([]);
 

// Inside your component function
const [searchParams] = useSearchParams();

useEffect(() => {
  const table = searchParams.get('table');
  const room = searchParams.get('room');

  if (table && table.trim() !== '') {
    setTableNumber(table);    
  }

  if (room && room.trim() !== '') {
    setRoomNumber(room);
  }
}, [searchParams]);

  // Toggle category expansion
  // const toggleCategory = (category) => {
  //   setOpenCategory((prev) => (prev === category ? null : category));
  // };
  const toggleCategory = (category) => {
    // Prevent default button behavior
    // e.preventDefault();
    // event.stopPropagation();
    
    if (openCategories.includes(category)) {
      // Remove this category to close it
      setOpenCategories(openCategories.filter(cat => cat !== category));
    } else {
      // Add this category to open it
      setOpenCategories([...openCategories, category]);
    }
  };
  // Toggle item selection


  // Check if service is active
  useEffect(() => {
    if (userData?.nextPaymentDate) {
      const nextPaymentDate = new Date(userData.nextPaymentDate);
      const cutoffDate = new Date(nextPaymentDate);
      cutoffDate.setDate(cutoffDate.getDate() + 5); // Next Payment Date + 5 Days
      //console.log('cut of date,',cutoffDate)
      setIsServiceActive(new Date() <= cutoffDate);
    }
    
    // Set business type and delivery availability based on userData
    if (userData) {
      setBusinessType(userData?.businessType);
      setDeliveryAvailable(userData?.homeDeliveryAvailable);
      setTakeAwayAvailable(userData?.takeAwayAvailable);
      setOrderOption(!userData?.homeDeliveryAvailable && 'dine-in')
    }
  }, [userData]);

  //console.log("menu data", menuData)

  useEffect(() => {
    if (!businessId) {
      setError("Business Id is missing from the URL.");
      setLoading(false);
      return;
    }



    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    const fetchBusinessAndUser = async () => {
      try {
        const menuDocRef = doc(db, "menus", businessId);
        const menuSnap = await getDoc(menuDocRef);

        if (menuSnap.exists()) {
          const menuData = menuSnap.data();
          setMenuData(menuData);
          const email = menuData.email;

          if (email) {
            const userDocRef = doc(db, "userDetails", email);
            const userSnap = await getDoc(userDocRef);

            if (userSnap.exists()) {
              const userData = userSnap.data();
              setUserData(userData);
              setBusinessType(userData.businessType || 'Restaurant');
              setDeliveryAvailable(userData.deliveryAvailable || false);
              setTakeAwayAvailable(userData?.takeAwayAvailable || false);
              await updateDoc(userDocRef, {
                menuShown: increment(1),
              });
            } else {
              setError("User details not found.");
            }
          }
        } else {
          setError("Business not found.");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to fetch details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessAndUser();
  }, [businessId]);

  let groupedData;
  if(menuData?.englishMenu){
     groupedData = menuData?.[selectedLanguage].reduce((acc, item) => {
      acc[item['Level 1']] = acc[item['Level 1']] || [];
      acc[item['Level 1']].push(item);
      return acc;
    }, {});  
  }else{
    groupedData = menuData?.hindiMenu.reduce((acc, item) => {
      acc[item['Level 1']] = acc[item['Level 1']] || [];
      acc[item['Level 1']].push(item);
      return acc;
    }, {});  
  }

  useEffect(() => {
    let myData;
    if(menuData?.englishMenu){
      myData = menuData?.[selectedLanguage].reduce((acc, item) => {
        acc[item['Level 1']] = acc[item['Level 1']] || [];
        acc[item['Level 1']].push(item);
        return acc;
      }, {}); 
    }else{
       myData = menuData?.hindiMenu?.reduce((acc, item) => {
        acc[item['Level 1']] = acc[item['Level 1']] || [];
        acc[item['Level 1']].push(item);
        return acc;
      }, {});  
    }
      
      if(myData){
        setOpenCategories(Object.keys(myData))
      }
  },[menuData])

  // Function to remove duplicates
  const removeDuplicates = (items) => {
    const uniqueItems = [];
    const seen = new Set();
    items.forEach((item) => {
      const key = `${item['Item Name']}-${item['Price']}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueItems.push(item);
        
      }
    });
    //console.log(uniqueItems);
    return uniqueItems;
  };

  // Handle language change
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };


  // Get all selected items' details
  const getSelectedItemsDetails = () => {
    const allItems = [];
    Object.keys(groupedData || {}).forEach(category => {
      groupedData[category].forEach(item => {
        const uniqueKey = `${category}-${item["Item Name"]}-${item["Price"]}`;
        //console.log("jeyyyykeyyyyy keyyy", uniqueKey)
        Object.entries(itemQuantities)?.forEach(([key, value]) => {
          const myItem = key.split('-');
          //console.log('my item new qith quant', myItem)
          //console.log("hello world", key, 'val', value)
        })
        if (selectedItems.has(uniqueKey)) {
          allItems.push({
            ...item,
            category,
            uniqueKey,
          });
        }
      });
    });
    return allItems;
  };

  // Handle NEXT button click - Show order summary popup
  const handleNext = () => {
    if (selectedItems.size === 0) {
      alert("Please select at least one item before proceeding.");
      return;
    }
    
    const itemDetails = getSelectedItemsDetails();
    //console.log("item details", itemDetails)
    setSelectedItemsDetails(itemDetails);
    setShowOrderSummary(true);
  };
  //console.log("selected items details", selectedItemsDetails)
  // Close summary popup
  const closeSummary = () => {
    setShowOrderSummary(false);
    setOrderOption('');
    setShowOrderDetails(false);
    //setTableNumber('');
    //setRoomNumber('');
    //setDeliveryAddress('');
  };

  const resetSummary = () => {
    setShowOrderSummary(false);
    setOrderOption('');
    setShowOrderDetails(false);
    //setTableNumber('');
    //setRoomNumber('');
    //setDeliveryAddress('');
    setSelectedItems(new Set());
   
    
  };

  // Handle order option selection
  const handleOrderOption = (option) => {
    setOrderOption(option);
    setShowOrderDetails(true);
  };

  // Generate order details string for URL
  const generateOrderString = () => {
    // Create a string with selected items

    // const itemsString = selectedItemsDetails
    //   .map(item => `${item["Item Name"]} (₹${item["Price"]})`)
    //   .join(', ');
      const itemsString = selectedItemsDetails
    .map(item => {
      const quantity = itemQuantities[item.uniqueKey] || 0; // Get the quantity
      const totalPrice = item["Price"] * quantity;          // Calculate total for this item
      return `${item["Item Name"]} x${quantity} (₹${totalPrice})`;
    })
    .join(', ');
      
    // Add location information based on business type and delivery option
    let locationInfo = '';
    if (orderOption === 'dine-in') {
      if (businessType === 'Restaurant') {
        locationInfo = `Table: ${tableNumber}`;
      } else if (businessType === 'Hotel') {
        locationInfo = `Room: ${roomNumber}`;
      }
    } else if (orderOption === 'delivery') {
      locationInfo = `Delivery Address: ${deliveryAddress}`;
    }else if(orderOption === 'takeAway'){
      locationInfo = 'Take Away';
    }
    const instructionsInfo = cookingInstructions ? `Cooking Instructions: ${cookingInstructions}` : 'None';
    const customerPhoneInfo = customerPhone ? `Phone Number: ${customerPhone}` : '';
    const customerNameInfo = customerName ? `Customer Name: ${customerName}` : '';
    
    //console.log('real id o========', `Items: ${itemsString} | ${locationInfo} | Total: ₹${calculateTotal()}`)
    // Combine everything into one string
    return `Items: ${itemsString} | ${locationInfo} ${instructionsInfo && `| ${instructionsInfo}`} ${customerPhoneInfo && `| ${customerPhoneInfo}`} ${customerNameInfo && `| ${customerNameInfo}`} | Total: ₹${calculateTotal()}`;
  };

  // Handle place order
  const handlePlaceOrder = () => {
    if (!customerName) {
      alert('Please enter your name');
      return;
    }

    if (!customerPhone || !/^\d{10}$/.test(customerPhone)) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }
  
    // Validate required fields
    if (orderOption === 'dine-in') {
      if (businessType === 'Restaurant' && !tableNumber) {
        alert('For Dine-In orders, please scan the QR code located on your table.');
        return;
      }
      if (businessType === 'Hotel' && !roomNumber) {
        alert('For In-Room Dine-In orders, please scan the QR code provided in your room.');
        return;
      }
    } else if (orderOption === 'delivery' && !deliveryAddress) {
      alert('Please enter a delivery address');
      return;
    }
  
    resetSummary();
    // Generate order string for URL
    // const orderString = encodeURIComponent(generateOrderString());
    
    // Create URL with order details (you can modify this to match your app's routing)

    const createWhatsAppLink = (phoneNumber, message) => {
      const formatted = formatWhatsAppOrderMessage(message);
      const formattedMessage = encodeURIComponent(formatted);
      return `https://wa.me/${phoneNumber}?text=${formattedMessage}`;
    };
    

    //format the message for whatsapp

    const formatWhatsAppOrderMessage = (rawMessage) => {
  const itemsMatch = rawMessage.match(/Items:\s*(.*?)\s*\|/);
  const tableMatch = rawMessage.match(/Table:\s*(.*?)\s*\|/);
  const deliveryAddressMatch = rawMessage.match(/Delivery Address:\s*(.*?)\s*\|/);
  const instructionsMatch = rawMessage.match(/Cooking Instructions:\s*(.*?)\s*\|/);
  const phoneMatch = rawMessage.match(/Phone Number:\s*(.*?)\s*\|/);
  const nameMatch = rawMessage.match(/Customer Name:\s*(.*?)\s*\|/);
  const totalMatch = rawMessage.match(/Total:\s*(₹[0-9]+)/);

  const items = itemsMatch?.[1] || "N/A";
  const tableNumber = tableMatch?.[1];
  const deliveryAddress = deliveryAddressMatch?.[1];
  const instructions = instructionsMatch?.[1] || "None";
  const phone = phoneMatch?.[1] || "N/A";
  const name = nameMatch?.[1] || "N/A";
  const total = totalMatch?.[1] || "₹0";

  const lowerMsg = rawMessage.toLowerCase();

  let orderTypeInfo = "";

  if (deliveryAddress) {
    orderTypeInfo = `*Delivery Address:* ${deliveryAddress}`;
  } else if (lowerMsg.includes("take away")) {
    orderTypeInfo = `*Order Type:* Takeaway`;
  } else if (lowerMsg.includes("room:")) {
    const roomMatch = rawMessage.match(/Room:\s*(.*?)\s*\|/i);
    const roomNumber = roomMatch?.[1] || "N/A";
    orderTypeInfo = `*Room Number:* ${roomNumber}`;
  } else {
    orderTypeInfo = `*Table No:* ${tableNumber || "N/A"}`;
  }

  const message = `
*New Order Received*  
*Customer:* ${name}  
*Phone:* ${phone}  
${orderTypeInfo}

*Items Ordered:*  
${items}

*Cooking Instructions:* ${instructions}

*Total:* ${total}

Please confirm the order.
  `.trim();

  return message;
};




    // Place Order button click handler
    const handlePlaceOrderFunc = async () => {
      const phoneNumber = userData?.whatsappNumber;
      const email = userData?.email;
      const rawMessage = generateOrderString();
      const orderId = uuidv4();
      const createdDateTime = new Date().toISOString();
    
       // Open WhatsApp with encoded message
       const whatsappLink = createWhatsAppLink(phoneNumber, rawMessage);
       window.open(whatsappLink, '_blank');

      try {
        // Store in Firestore
        await setDoc(doc(collection(db, 'orders'), orderId), {
          orderId: orderId,
          order: rawMessage,
          createdDateTime: createdDateTime,
          createdDateTimeFormatted: Timestamp.now(),
          email: email,
          delivered: false // <<<<<<<< ADD this line correctly
        });
    
       
    
      } catch (error) {
        console.error('Failed to store order in Firestore:', error);
      }
    };
    handlePlaceOrderFunc();
    // const orderUrl = `/order-confirmation/${businessId}?details=${orderString}`;
    // console.log("order url", orderUrl)
    // Navigate to the URL (in a real app, you would use React Router's navigate)
    // window.location.href = orderUrl;
  };

  // Remove item from selection within the summary popup
  const removeItemFromSelection = (uniqueKey) => {
    setSelectedItems(prev => {
      const newSet = new Set(prev);
      newSet.delete(uniqueKey);
      return newSet;
    });
    
    setSelectedItemsDetails(prev => 
      prev.filter(item => item.uniqueKey !== uniqueKey)
    );
    
    // If all items are removed, close the popup
    if (selectedItems.size <= 1) {
      setShowOrderSummary(false);
    }
  };

  // Calculate total order amount
  // const calculateTotal = () => {
  //   return selectedItemsDetails.reduce((total, item) => 
  //     total + Number(item["Price"]), 0
  //   );
  // };
  const calculateTotal = () => {
    return selectedItemsDetails.reduce((total, item) => {
      const quantity = itemQuantities[item.uniqueKey] || 0;
      return total + (Number(item["Price"]) * quantity);
    }, 0);
  };
  

  if (loading) return <Loading />;
  if (error) return <p>{error}</p>;

  if (!isServiceActive || !userData?.lastPaymentAmount) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="bg-white p-8 rounded-xl shadow-lg text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">
            This service has been stopped by ZAFFLO because of Pending Payment Issue
          </h2>
          <p className="text-gray-700">Please contact support to resolve the issue.</p>
        </div>
      </div>
    );
  }

  // Add new type of Level 1 Menu category here to select proper icon
  const getCategoryIcon = (category) => {
    const categoryMap = {
      'Breakfast': <GiHotMeal className="text-yellow-600" />,
      'Main Course': <MdFoodBank className="text-red-600" />,
      'Appetizers': <GiFruitBowl className="text-green-600" />,
      'Desserts': <FaHeart className="text-pink-600" />,
      'Beverages': <FaCocktail className="text-white-600" />,
      'Soups': <FaUtensils className="text-orange-600" />,
      'Drinks': <FaCocktail className="text-white-600" />,
      'पेय': <FaCocktail className="text-white-600" />,
    };
    
    return categoryMap[category] || <MdRestaurantMenu className="text-white-600" />;
  };
 // console.log('scdscscsc',userData);


// Function to toggle selection of an item
const toggleSelectionQuantity = (uniqueKey) => {
  const newSelectedItems = new Set(selectedItems);
  
  if (newSelectedItems.has(uniqueKey)) {
    newSelectedItems.delete(uniqueKey);
    // Remove from quantities as well
    const newQuantities = {...itemQuantities};
    delete newQuantities[uniqueKey];
    setItemQuantities(newQuantities);
  } else {
    newSelectedItems.add(uniqueKey);
    // Initialize quantity to 1
    setItemQuantities({...itemQuantities, [uniqueKey]: 1});
  }
  //console.log('sdcsdcsdc', newSelectedItems, 'quantity', itemQuantities)
  setSelectedItems(newSelectedItems);
};
//console.log('sdcsdcsdc', selectedItems, 'quantity', itemQuantities)

// Function to adjust quantity
const adjustQuantity = (uniqueKey, change) => {
  const currentQuantity = itemQuantities[uniqueKey] || 1;
  const newQuantity = Math.max(1, currentQuantity + change);
  
  setItemQuantities({
    ...itemQuantities,
    [uniqueKey]: newQuantity
  });
};

// Function to get current quantity of an item
const getItemQuantity = (uniqueKey) => {
  return itemQuantities[uniqueKey] || 1;
};

function findQuantity(item) {
  const quantity = itemQuantities[item.uniqueKey] || 0; // Find quantity or default to 0
  return (
    <div className="flex items-center mr-3">
      <span className="px-2 py-1 bg-orange-200 rounded-lg text-sm font-semibold">
        {quantity}x
      </span>
    </div>
  );
}



function calculatePrice(item) {
  const quantity = itemQuantities[item.uniqueKey] || 0;
  return item.Price * quantity; // Multiply price by quantity
}
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 p-4 sm:p-8 font-sans">
  {/* Decorative header background */}
  <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-r from-amber-500 to-orange-400 rounded-b-3xl -z-10 opacity-20"></div>
 
  {/* Main content */}
  <div className="relative max-w-6xl mx-auto">
   {/*<FloatingMenu />*/}
   
    {/* Header with decorative elements */}
    <div className="mb-12 text-center relative">
      {userData?.logo && 
        <div className="text-amber-300 opacity-75 flex justify-center">
          <img src={userData?.logo} className='w-auto h-20' alt="business logo"/>
        </div>
      }
     
      <h1 className="text-4xl sm:text-5xl font-bold text-amber-900 mb-4 pt-4 font-sans">
        {userData?.businessName}
      </h1>
      
      <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-orange-500 mx-auto my-4 rounded-full"></div>
      
      <p className="text-amber-800 text-lg md:text-xl max-w-2xl mx-auto">
        Welcome to our Digital Menu, Please add items and place your orders.
      </p>
    </div>

    {/* Selected items counter & Next button - Fixed to bottom */}
    {selectedItems.size > 0 && (
      <div className="fixed bottom-4 left-0 right-1 z-20 px-12">
        <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg p-4 flex items-center justify-between">
          <div className="flex items-center">
            <div className="bg-amber-500 text-white rounded-full h-8 w-8 flex items-center justify-center mr-2">
              <FaShoppingCart />
            </div>
            <span className="font-bold text-amber-900">
              {selectedItems.size} {selectedItems.size === 1 ? 'item' : 'items'} added
            </span>
          </div>
          <button 
            onClick={handleNext}
            className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-2 rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-300"
          >
            NEXT
          </button>
        </div>
      </div>
    )}

    {/* Language Selection */}
    {menuData?.englishMenu && menuData?.hindiMenu ? (
      <div className="flex-1 mb-10">
        <div className="flex p-1 justify-end">
          {menuData?.englishMenu && (
            <button
              onClick={() => handleLanguageChange('englishMenu')}
              className={`py-3 px-4 rounded-xl shadow-md bg-orange flex items-center justify-center space-x-2 transition-all duration-300 ${
                selectedLanguage === 'englishMenu'
                  ? 'bg-amber-600 text-white shadow-md transform scale-105'
                  : 'text-gray-700 hover:bg-amber-100'
              }`}
            >
              <FaLanguage size={20} />
              <span className="font-medium">English</span>
            </button>
          )}
          
          {menuData?.hindiMenu && (
            <button
              onClick={() => handleLanguageChange('hindiMenu')}
              className={`py-3 ml-5 px-4 rounded-xl shadow-md bg-orange flex items-center justify-center space-x-2 transition-all duration-300 ${
                selectedLanguage === 'hindiMenu'
                  ? 'bg-amber-600 text-white shadow-md transform scale-105'
                  : 'text-gray-700 hover:bg-amber-100'
              }`}
            >
              <FaLanguage size={20} />
              <span className="font-medium">Indian</span>
            </button>
          )}
        </div>
      </div>
    ) : null}
   
    {/*Menu Section */}
  {!!menuData && (
    <div className="max-w-6xl mx-auto space-y-4 sm:space-y-6">
      <FloatingMenu menuItems={menuDataPP} className="scale-120" />
      {Object.keys(groupedData).map((category) => (
        <div key={category} className="overflow-hidden transition-all duration-300">
          <button
            onClick={(e) => {
              e.preventDefault();
              toggleCategory(category);
            }}
            className={`w-full flex items-center justify-between text-lg sm:text-xl font-bold px-6 py-5 rounded-2xl shadow-lg transition-all duration-300 ${
              openCategories.includes(category)
                ? 'bg-gradient-to-r from-amber-600 to-orange-500 text-white'
                : 'bg-white text-amber-900 hover:shadow-xl'
            }`}
          >
            <div className="flex items-center space-x-3">
              <div className="text-2xl sm:text-3xl">
                {getCategoryIcon(category)}
              </div>
              <span>{category}</span>
            </div>

            <div className={`text-xl transition-transform duration-300 ${
              openCategories.includes(category) ? 'rotate-180' : ''
            }`}>
              <FaChevronDown />
            </div>
          </button>

          {openCategories.includes(category) && (
            <div className="mt-4 bg-white rounded-2xl shadow-xl overflow-hidden animate-fadeIn">
              {(() => {
                const categoryItems = groupedData[category] || [];
                const uniqueLevelTwoValues = [
                  ...new Set(
                    categoryItems
                      .filter(item => item["Level 2"]) 
                      .map(item => item["Level 2"])
                  )
                ];

                // Dynamically update menuDataPP to include unique Level 2 values
                uniqueLevelTwoValues.forEach((levelTwoValue) => {
                  if (!menuDataPP.some(item => item.label === levelTwoValue)) {
                    setMenuDataPP(prevMenuDataPP => [
                      ...prevMenuDataPP,
                      { label: levelTwoValue, href: `#${levelTwoValue}` }
                    ]);
                  }
                });

                return uniqueLevelTwoValues.map(levelTwoValue => {
                  let filteredItems = categoryItems.filter(item => item["Level 2"] === levelTwoValue);
                  filteredItems = removeDuplicates(filteredItems);

                  if (filteredItems.length === 0) return null;

                  let colorClass = "from-blue-500 to-indigo-600"; 

                  if (levelTwoValue.toLowerCase() === "veg") {
                    colorClass = "from-green-500 to-emerald-600";
                  } else if (levelTwoValue.toLowerCase() === "jain") {
                    colorClass = "from-yellow-500 to-amber-600";
                  } else if (levelTwoValue.toLowerCase() === "nonveg") {
                    colorClass = "from-red-500 to-rose-600";
                  } else if (levelTwoValue.toLowerCase() === "drink") {
                    colorClass = "from-blue-500 to-rose-600";
                  }

                  return (
                    <div key={levelTwoValue} id={levelTwoValue} className="p-6 border-b border-gray-100 last:border-b-0">
                      
                      <div className="mb-6">
                        <div className={`inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r ${colorClass} text-white shadow-md`}>
                          {levelTwoValue.toLowerCase() === "drink" && <FaCocktail className="mr-2" />}
                          {levelTwoValue.toLowerCase() === "veg" && <FaLeaf className="mr-2" />}
                          {levelTwoValue.toLowerCase() === "jain" && <FaLeaf className="mr-2" />}
                          {levelTwoValue.toLowerCase() === "nonveg" && <FaDrumstickBite className="mr-2" />}
                          <h3 className="font-medium">{levelTwoValue}</h3>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                        {filteredItems.map((item) => {
                          const uniqueKey = `${category}-${item["Item Name"]}-${item["Price"]}`;
                          return (
                            <div
                              key={uniqueKey}
                              className={`relative rounded-xl overflow-hidden group transition-all duration-300 ${
                                selectedItems.has(uniqueKey)
                                  ? 'ring-2 ring-amber-500 shadow-amber-200 shadow-lg'
                                  : 'shadow-md hover:shadow-xl'
                              }`}
                            >
                              <div className="absolute inset-0 bg-gray-100"></div>

                              <div className="absolute top-2 right-2 z-10">
                                <span className={`inline-flex items-center justify-center h-5 w-5 rounded-full ${
                                  item["Veg_NonVeg"] === "Veg"
                                    ? "bg-green-500"
                                    : item["Veg_NonVeg"] === "drink"
                                    ? "bg-blue-500"
                                    : "bg-red-500"
                                }`}>
                                  {item["Veg_NonVeg"] === "Veg"
                                    ? <FaLeaf className="text-white text-xs" />
                                    : item["Veg_NonVeg"] === "drink"
                                    ? <FaCocktail className="text-white text-xs" />
                                    : <FaDrumstickBite className="text-white text-xs" />
                                  }
                                </span>
                              </div>

                              <div className="relative p-3 z-6 bg-white">
                                <div className="min-h-18 max-h-22">
                                  <h4 className="text-base font-bold text-gray-900 group-hover:text-amber-600 transition-colors line-clamp-2">
                                    {item["Item Name"]}
                                  </h4>

                                  <p className="text-gray-600 text-xs mt-1 line-clamp-4">
                                    {item["Item Description"] || ""}
                                  </p>
                                </div>

                                <div className="mt-2 pt-2 border-t border-gray-100">
                                  <p className="text-amber-600 font-bold text-lg">₹{item["Price"]}</p>

                                  {selectedItems.has(uniqueKey) ? (
                                    <div className="flex items-center justify-between mt-2 ">
                                      <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                                        <button
                                          onClick={() => adjustQuantity(uniqueKey, -1)}
                                          className="px-2 sm:px-2 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold"
                                        >
                                          -
                                        </button>
                                        <span className="px-1 sm:px-3 py-1 text-center w-4 sm:w-8">
                                          {getItemQuantity(uniqueKey)}
                                        </span>
                                        <button
                                          onClick={() => adjustQuantity(uniqueKey, 1)}
                                          className="px-2 sm:px-2  py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold"
                                        >
                                          +
                                        </button>
                                      </div>
                                      <button
                                        onClick={() => toggleSelectionQuantity(uniqueKey)}
                                      >
                                        <MdDelete size={22} className="text-red-500 hover:text-red-800 "/>
                                      </button>
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() => toggleSelectionQuantity(uniqueKey)}
                                      className="mt-2 w-full py-1.5 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors text-sm font-medium"
                                    >
                                      Add
                                    </button>
                                  )}
                                </div>
                                {item["Level 2"] === "Jain" && (
                                  <span className="absolute top-2 right-2 px-1 py-0.5 bg-yellow-100 text-yellow-800 text-xs font-medium rounded">
                                    Jain
                                  </span>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          )}
        </div>
      ))}
    </div>
  )}

  {/* </div>
</div> */}
        
        {/* Footer decoration */}
        <div className="mt-16 text-center opacity-70 pb-20"> {/* Added padding to account for fixed bottom bar */}
          <GiChefToque size={40} className="text-[#6cbb23] mx-auto" />
          <p className="text-amber-700 mt-2">{userData?.businessName}!</p>
          <p className="m-0 text-xs">
        &copy; {new Date().getFullYear()} All rights reserved | This website is made
        <i className="fa fa-heart-o text-red-500" aria-hidden="true" /> by{' '}
        <a href="https://zafflo.com" target="_blank" rel="noreferrer" className="text-[#6cbb23] hover:underline">
        <strong>ZAFFLO</strong>
        </a>
      </p>
        </div>
      </div>

      {/* Order Summary Popup */}
    

{showOrderSummary && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-screen overflow-y-auto">
      {/* Popup Header */}
      <div className="border-b border-gray-100 p-6">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold text-amber-900">Order Summary</h2>
         
          <button 
            onClick={closeSummary}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <FaTimes size={20} />
          </button>
        </div>
      </div>
      
      {/* Order Items */}
      <div className="p-6">
        <div className="space-y-4 max-h-64 overflow-y-auto">
        {selectedItemsDetails.map((item) => (
  <div key={item.uniqueKey} className="flex justify-between items-center p-3 bg-amber-50 rounded-lg">
    
    <div className="flex items-center">
      <span
        className={`inline-flex items-center justify-center h-6 w-6 rounded-full mr-3 ${
          item["Veg_NonVeg"] === "Veg" ? "bg-green-500" :  item["Veg_NonVeg"] === "drink" ? "bg-blue-500" : "bg-red-500"
        }`}
      >
        {item["Veg_NonVeg"] === "Veg" ? (
          <FaLeaf className="text-white text-xs" />
        ) :  item["Veg_NonVeg"] === "drink" ?
        (
          <FaCocktail className="text-white text-xs" />
        )
        
        :(
          <FaDrumstickBite className="text-white text-xs" />
        )}
      </span>
      <div className='mr-3'>
        <h4 className="font-medium text-gray-900">{item["Item Name"]}</h4>
        <p className="text-sm text-gray-600">{item.category}</p>
      </div>
      {findQuantity(item)}
    </div>
    
    <div className="flex items-center">
      <p className="font-bold text-amber-600 mr-4">₹{calculatePrice(item)}</p>
      <button
        onClick={() => removeItemFromSelection(item.uniqueKey)}
        className="text-gray-400 hover:text-red-500 transition-colors"
      >
        <FaTimes />
      </button>
    </div>
  </div>
))}
        </div>
        
        {/* Order Total */}
        <div className="mt-6 py-4 border-t border-b border-gray-100">
          <div className="flex justify-between items-center">
            <p className="text-xl font-bold text-gray-900">Total Amount:</p>
            <p className="text-2xl font-bold text-amber-600">₹{calculateTotal()}</p>
          </div>
          <p className="text-xs text-black">Taxes, if any, will be charged as per applicable laws.</p>
        </div>
        
  {/* Order Total */}
  <div className="mt-2 py-1">
  <div className="flex gap-4">
    <input
      type="text"
      id="customerName"
      value={customerName}
      onChange={(e) => setCustomerName(e.target.value)}
      placeholder="Your Name *"
      className="w-1/2 text-xs px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
    />
    <input
      type="tel"
      id="customerPhone"
      value={customerPhone}
      onChange={(e) => setCustomerPhone(e.target.value)}
      placeholder="Mobile Number *"
      className="w-1/2 text-xs px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
      required
    />
  </div>
</div>
<div className="mt-2"> 
<div className="flex justify-between items-center mb-1">
    <p className="text-xs text-gray-900">Add cooking instructions (Optional)</p>
  </div>
<input
      type="text"
      id="cookingInstructions"
      value={cookingInstructions}
      onChange={(e) => setCookingInstructions(e.target.value)}
      placeholder="e.g. Don't make it too spicy"
      className="w-full text-xs px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
    />
</div>

        {/* Order Options - Only show if not showing details yet */}
        {!showOrderDetails && (
          <div className="mt-2">
            {/* For Restaurant with Delivery Available */}
            {businessType === 'Restaurant' && deliveryAvailable && !takeAwayAvailable && (
              <>
                <h3 className="text-lg font-medium text-gray-900 mb-4">What would you like to do?</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {(tableNumber) && (
                  <button
                    onClick={() => handleOrderOption('dine-in')}
                    className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <MdRestaurantMenu size={32} className="mb-2" />
                    <span>Dine In</span>
                  </button>
                )}
                  <button
                    onClick={() => handleOrderOption('delivery')}
                    className="relative p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <span className="absolute top-1 right-2 text-[7px] text-amber-600">📍Address</span>
                    <MdDeliveryDining size={32} className="mb-2" />
                    <span>Home Delivery</span>
                  </button>
                </div>
              </>
            )}

          {businessType === 'Restaurant' && deliveryAvailable && !!takeAwayAvailable && (
              <>  
                <h3 className="text-lg font-medium text-gray-900 mb-4">What would you like to do?</h3>
                <div className="grid grid-cols-3 sm:grid-cols-3 gap-4">
                {(tableNumber) && (
                  <button
                    onClick={() => handleOrderOption('dine-in')}
                    className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <MdRestaurantMenu size={32} className="mb-2" />
                    <span>Dine In</span>
                  </button>
                )}
              <button
  onClick={() => handleOrderOption('delivery')}
  className="relative p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
>
  <span className="absolute top-1 center text-[7px] text-amber-600">📍Address</span>
  <MdDeliveryDining size={32} className="mb-2" />
  <span>Home Delivery</span>
</button>
                  <button
                    onClick={() => handleOrderOption('takeAway')}
                    className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <MdTakeoutDining size={32} className="mb-2" />
                    <span>Take Away</span>
                  
                  </button>
                </div>
              </>
            )}
            
            {/* For Hotel with Delivery Available */}
            {/* {businessType === 'Hotel' && deliveryAvailable && (
              <>
                <h3 className="text-lg font-medium text-gray-900 mb-4">What would you like to do?</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <button
                    onClick={() => handleOrderOption('dine-in')}
                    className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <MdRestaurantMenu size={32} className="mb-2" />
                    <span>Dine In</span>
                  </button>
                  
                  <button
                    onClick={() => handleOrderOption('delivery')}
                    className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <MdDeliveryDining size={32} className="mb-2" />
                    <span>Home Delivery</span>
                  </button>
                </div>
              </>
            )} */}
            
            {/* For Restaurant with No Delivery - Skip options, go directly to table entry */}
            {businessType === 'Restaurant' && !deliveryAvailable && !takeAwayAvailable && (
              <div>
                {/*<h3 className="text-lg font-medium text-gray-900 mb-4">Enter Your Details</h3>*/}
                <label htmlFor="tableNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                  <FaBuilding className="mr-2" /> Table Number : {tableNumber}
                </label>
                <input
                  type="text"
                  id="tableNumber"
                  value={tableNumber}
                  onChange={(e) => setTableNumber(e.target.value)}
                  placeholder="Enter your table number"
                  className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                  required
                />
                <div className="mt-6">
                  <button
                    onClick={handlePlaceOrder}
                    className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-all duration-300"
                  >
                    Place Order
                  </button>
                </div>
              </div>
            )}

            {businessType === 'Restaurant' && !deliveryAvailable && takeAwayAvailable && (
              <div>
                {/*<h3 className="text-lg font-medium text-gray-900 mb-4">Enter Your Details</h3>*/}
                <label htmlFor="tableNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                  <FaBuilding className="mr-2" /> Table Number : {tableNumber}
                </label>
                <input
                  type="text"
                  id="tableNumber"
                  value={tableNumber}
                  onChange={(e) => setTableNumber(e.target.value)}
                  placeholder="Enter your table number"
                  className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                  required
                />
                <div className="mt-6">
                  <button
                    onClick={handlePlaceOrder}
                    className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-all duration-300"
                  >
                    Place Order
                  </button>
                </div>
                <h2 className='text-center'>Or</h2>
                <div className="mt-1">
                  <button
                    onClick={handlePlaceOrder}
                    className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-all duration-300"
                  >
                   Take Away
                  </button>
                </div>
              </div>
            )}

            {/* For Hotel with No Delivery - Skip options, go directly to room entry */}
            {businessType === 'Hotel' && (
              <div>
                {/*<h3 className="text-lg font-medium text-gray-900 mb-4">Enter Your Details</h3>*/}
                <label htmlFor="roomNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                  <FaBuilding className="mr-2" /> Room Number : {roomNumber}
                </label>
                <input
                  type="text"
                  id="roomNumber"
                  value={roomNumber}
                  onChange={(e) => setRoomNumber(e.target.value)}
                  placeholder="Enter your room number"
                  className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                  required
                />
                <div className="mt-6">
                  <button
                    onClick={handlePlaceOrder}
                    className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-all duration-300"
                  >
                    Place Order
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        




        {/* Conditional Order Details Form - Only show after option selection */}
        {showOrderDetails && (
          <div className="mt-6">
            {/* <h3 className="text-lg font-medium text-gray-900 mb-4">Order Details</h3>*/}
            
            {/* Dine In - Table/Room Number */}
            {orderOption === 'dine-in' && (
              <div className="mb-4">
                {businessType === 'Restaurant' && (
                  <div>
                    <label htmlFor="tableNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                      <FaBuilding className="mr-2" /> Table Number : {tableNumber}
                    </label>
                    <input
                      type="text"
                      id="tableNumber"
                      value={tableNumber}
                      onChange={(e) => setTableNumber(e.target.value)}
                      placeholder="Enter your table number"
                      className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                      required
                      readOnly
                    />
                  </div>
                )}
                
                {userData?.businessType === 'Hotel' && (
                  <div>
                    <label htmlFor="roomNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                      <FaBuilding className="mr-2" /> Room Number : {roomNumber}
                    </label>
                    <input
                      type="text"
                      id="roomNumber"
                      value={roomNumber}
                      onChange={(e) => setRoomNumber(e.target.value)}
                      placeholder="Enter your room number"
                      className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                      required
                      readOnly
                    />
                  </div>
                )}
              </div>
            )}
            
            {/* Delivery Address */}
            {orderOption === 'delivery' && (
              <div className="mb-4">
                <div>
                  <label htmlFor="deliveryAddress" className="block text-gray-700 font-medium mb-2 flex items-center">
                    <FaHome className="mr-2" /> Delivery Address
                  </label>
                  <input
                    type="text"
                    id="deliveryAddress"
                    value={deliveryAddress}
                    onChange={(e) => setDeliveryAddress(e.target.value)}
                    placeholder="Enter your delivery address"
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                    required
                  />
                </div>
              </div>
            )}

            {orderOption === 'takeAway' && (
              <div className="mb-4">
                <div>
                  <label htmlFor="deliveryAddress" className="text-gray-700  mb-2 flex font-semibold items-center">
                    <MdTakeoutDining className="mr-2" /> Take Away
                  </label>
                </div>
              </div>
            )}


            {/* Place Order Button */}
            <div className="mt-6">
              <button
                onClick={handlePlaceOrder}
                className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-all duration-300"
              >
                Place Order
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
)}



    </div>




  );

 

}

